import {
  GET_VIDEOS_REQUEST,
  GET_VIDEOS_SUCCESS,
  GET_VIDEOS_ERROR,
  GET_VIDEOS_DONE,
  ADD_VIDEOS_REQUEST,
  DELETE_VIDEO_REQUEST,
  INCREMENT_VIDEO_INDEX_REQUEST,
  DECREMENT_VIDEO_INDEX_REQUEST,
  UPDATE_VIDEOS_REQUEST,
} from "./actions";

const initialState = {
  requesting: false,
  successful: false,
};

const reducer = (state = initialState, action) => {
  let index;
  let videos;

  switch (action.type) {
    case GET_VIDEOS_REQUEST:
      return {
        requesting: true,
        successful: false,
        videos: undefined,
        error: undefined,
      };

    case GET_VIDEOS_SUCCESS:
      return {
        requesting: false,
        successful: true,
        videos: action.videos,
        error: undefined,
      };

    case GET_VIDEOS_ERROR:
      return {
        requesting: false,
        successful: false,
        videos: undefined,
        error: action.error,
      };

    case GET_VIDEOS_DONE:
      return {
        ...initialState,
        successful: state.successful,
        videos: state.videos,
      };

    case ADD_VIDEOS_REQUEST:
      return {
        ...state,
        videos: [...state.videos, ...action.videos],
      };

    case UPDATE_VIDEOS_REQUEST:
      return {
        ...state,
        videos: state.videos.map((video) => {
          if (video !== action.video) {
            return video;
          }

          return {
            ...action.video,
            videoTitle: action.data.videoTitle,
            description: action.data.description,
          };
        }),
      };

    case DELETE_VIDEO_REQUEST:
      return {
        ...state,
        videos: state.videos.filter((video) => video !== action.video),
      };

    case INCREMENT_VIDEO_INDEX_REQUEST:
      index = state.videos.indexOf(action.video) - 1;
      if (index < 0) {
        index = 0;
      }
      videos = state.videos.filter((video) => video !== action.video);
      videos.splice(index, 0, action.video);
      return {
        ...state,
        videos,
      };

    case DECREMENT_VIDEO_INDEX_REQUEST:
      index = state.videos.indexOf(action.video) + 1;
      if (index >= state.videos.length) {
        index = state.videos.length - 1;
      }
      videos = state.videos.filter((video) => video !== action.video);
      videos.splice(index, 0, action.video);
      return {
        ...state,
        videos,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/playlists/form/videos/reducer.js